export let SocialMedia = /*#__PURE__*/function (SocialMedia) {
  SocialMedia["Facebook"] = "facebook";
  SocialMedia["Instagram"] = "instagram";
  SocialMedia["Linkedin"] = "linkedin";
  SocialMedia["Twitter"] = "twitter";
  SocialMedia["Youtube"] = "youtube";
  return SocialMedia;
}({});